import { render } from "./AttributeFormModal.vue?vue&type=template&id=01c008d0&scoped=true"
import script from "./AttributeFormModal.vue?vue&type=script&lang=js"
export * from "./AttributeFormModal.vue?vue&type=script&lang=js"

import "./AttributeFormModal.vue?vue&type=style&index=0&id=01c008d0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c008d0"]])

export default __exports__